import React, { useState } from 'react';
import { useEqualHeight } from 'common-react';
import IkzeExtendedEntrepreneurDepositDialog
  from '../IkzeExtendedEntrepreneurDeposit/IkzeExtendedEntrepreneurDepositDialog';
import { IkeOrIkzeLimits } from './IkeOrIkze';
import RetirementProductCard from './RetirementProductCard';
import { useRetirementProductConfigs } from './retirementProductConfigs';

import useStyles from './IkeOrIkzeDesktop.style';

const IkeOrIkzeDesktop: React.FC<{ limits: IkeOrIkzeLimits }> = ({ limits }) => {
  const [ikzeDialogOpen, setIkzeDialogOpen] = useState(false);
  const c = useStyles({});
  const { ikeConfig, ikzeConfig } = useRetirementProductConfigs();

  const { registerRef: registerEqualHeightRef } = useEqualHeight();

  return (
    <div className={c.root}>
      <RetirementProductCard
        config={ikeConfig}
        limits={limits}
        registerEqualHeightRef={registerEqualHeightRef}
      />

      <RetirementProductCard
        config={ikzeConfig}
        limits={limits}
        onOpenDialog={() => setIkzeDialogOpen(true)}
        registerEqualHeightRef={registerEqualHeightRef}
      />
      <IkzeExtendedEntrepreneurDepositDialog onClose={() => setIkzeDialogOpen(false)} open={ikzeDialogOpen} />
    </div>
  );
};

export default IkeOrIkzeDesktop;
